import WarningIcon from '@assets/media/warning.png';
import { Translation } from 'common/actions';
import Icon from 'common/components/Icon';
import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

interface StoreState {
  i18n: Translation;
}

interface UnsupportedCodecOverlayProps {
  i18n: Translation;
}

const UnsupportedCodecOverlay = ({ i18n }: UnsupportedCodecOverlayProps) => {
  if (isEmpty(i18n)) return null;

  return (
    <div className="player-overlay-container">
      <Icon size="veryLarge" src={WarningIcon} />
      <div className="player-overlay-title">{i18n.errorPage.unsupportedVideoTitle}</div>
      <div className="player-overlay-info">{i18n.errorPage.unsupportedVideoDescription}</div>
    </div>
  );
};

const mapStateToProps = ({ i18n }: StoreState) => ({
  i18n
});

export default React.memo(connect(mapStateToProps, {})(UnsupportedCodecOverlay));
